export default __webpack_public_path__ + "LogoCCIFranceWhite.b96d735.png";